import React, { useState } from 'react';
import { ChevronLeft, AlertCircle, Bug } from 'lucide-react';
import { Button } from '../components/Button';
interface ResetLinkExpiredProps {
  onBack: () => void;
  onRequestNew: () => void;
}
export function ResetLinkExpired({
  onBack,
  onRequestNew
}: ResetLinkExpiredProps) {
  const [showDebug, setShowDebug] = useState(false);
  return <div className="flex flex-col h-full w-full bg-stone-50 overflow-y-auto relative" data-id="element-1064">
      {/* Debug Toggle */}
      <button onClick={() => setShowDebug(!showDebug)} className="absolute top-8 right-2 z-40 w-7 h-7 rounded-full bg-slate-800/70 text-white flex items-center justify-center hover:bg-slate-800 transition-colors" title="Debug panel" data-id="element-1065">
        <Bug size={14} data-id="element-1066" />
      </button>

      {/* Debug Panel */}
      {showDebug && <div className="absolute top-16 right-2 z-40 bg-slate-800 text-white rounded-2xl p-3 shadow-xl w-56 text-xs animate-in fade-in zoom-in-95 duration-150" data-id="element-1067">
          <p className="font-bold text-slate-400 uppercase tracking-wider text-[10px] mb-2" data-id="element-1068">
            Debug Panel
          </p>
          <p className="text-slate-400 text-xs px-2 py-1" data-id="element-1069">
            This is the expired link state
          </p>
        </div>}

      {/* Header */}
      <div className="flex items-center justify-between p-6 pt-8 sticky top-0 bg-stone-50/90 backdrop-blur-md z-20" data-id="element-1070">
        <button onClick={onBack} className="p-2 -ml-2 rounded-full hover:bg-slate-200/50 text-slate-600 transition-colors" aria-label="Go back" data-id="element-1071">
          <ChevronLeft size={28} data-id="element-1072" />
        </button>
        <div className="w-12 h-12 rounded-2xl overflow-hidden border-2 border-white shadow-sm bg-stone-200" data-id="element-1073">
          <video autoPlay loop muted playsInline className="w-full h-full object-cover" src="https://cdn.magicpatterns.com/uploads/69mUG6ooMsKbP89Ta37mkt/Katethought_friendly_gym_mascot_character_funny_good_guy_musc_bc3cfd10-111a-4766-8e76-81af2852edc8_2.mp4" data-id="element-1074" />
        </div>
        <div className="w-10" data-id="element-1075" />
      </div>

      <div className="px-6 pb-8 flex-1 flex flex-col items-center justify-center" data-id="element-1076">
        {/* Icon */}
        <div className="w-20 h-20 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center mb-6" data-id="element-1077">
          <AlertCircle size={40} data-id="element-1078" />
        </div>

        {/* Content */}
        <div className="text-center mb-8 max-w-sm" data-id="element-1079">
          <h1 className="text-2xl font-extrabold text-slate-800 mb-3" data-id="element-1080">
            Link expired
          </h1>
          <p className="text-slate-600 font-medium leading-relaxed" data-id="element-1081">
            This reset link is no longer valid. Request a new one and try again.
          </p>
        </div>

        {/* Actions */}
        <div className="w-full max-w-sm space-y-4" data-id="element-1082">
          <Button type="button" variant="primary" fullWidth onClick={onRequestNew} data-id="element-1083">
            Request new link
          </Button>

          <button type="button" onClick={onBack} className="w-full text-center text-sm font-bold text-slate-600 hover:text-slate-800 py-2" data-id="element-1084">
            Back to Login
          </button>
        </div>
      </div>
    </div>;
}